import type {
    UpdateNewsCategoryResponseType,
    UpdateNewsCategoryRequestType
} from "./type";
import {
    request
} from "../request";

const UpdateNewsCategory = async (params: UpdateNewsCategoryRequestType): Promise<UpdateNewsCategoryResponseType> => {
    return await request<UpdateNewsCategoryResponseType>("/news/updateNewsCategory", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default UpdateNewsCategory;
